<script>
import CancelButton from '@/components/cars/edit/CancelButton.vue'
import TextHighlight from 'vue-text-highlight'

export default {
  components: {
    'mia-cancel-button': CancelButton,
    'vue-text-highlight': TextHighlight
  },

  props: {
    notification: {
      type: Object,
      required: true
    },

    highlight: {
      type: Array,
      default() {
        return []
      }
    }
  },

  methods: {
    translateContextType(contextType) {
      return {
        car: 'Fahrzeug',
        customer: 'Kunde',
        seller: 'Verkäufer',
        dispatchEmployee: 'Auslieferer'
      }[contextType] || contextType
    },

    getCustomerName(values) {
      return `${values.item_company || ''}, ${[values.item_salutation, values.item_title, values.item_firstname, values.item_name].join(' ')}`
        .replace(/^[\s]+/g, '')
        .replace(/^[,]+/g, '')
        .replace(/^[\s]+/g, '')
        .replace(/[\s]+$/g, '')
        .replace(/[,]+$/g, '')
        .replace(/[\s]+$/g, '')
        .replace(/[\s]+/g, ' ')
    }
  }
}
</script>

<template>
  <mia-modal
    classes="v--modal flex flex-col"
    width="40%"
    height="auto"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <mia-modal-header>
      <h3 class="py-0 my-0">
        Metadaten von Benachrichtigung <b>{{ notification.item_notification_label || notification.item_notification }}</b>
      </h3>
    </mia-modal-header>

    <div class="p-4 grid grid-cols-2 gap-x-4 gap-y-8">
      <div>
        <div class="font-bold">
          Versand an
        </div>
        <div class="mt-2">
          <a
            :href="`/mailto:/${notification.item_receiver}`"
            class="text-orange-mia hover:underline"
          >
            <vue-text-highlight :queries="highlight">{{ notification.item_receiver }}</vue-text-highlight>
          </a>
        </div>
      </div>
      <div
        v-for="(values, contextType) in notification.item_context"
        :key="contextType"
      >
        <div class="font-bold">
          {{ translateContextType(contextType) }}
        </div>
        <div class="mt-2">
          <template v-if="contextType === 'car'">
            <a
              :href="`/cars/${values.id}`"
              class="text-orange-mia hover:underline"
              target="_blank"
            >
              <vue-text-highlight :queries="highlight">[{{ values.id }}] {{ values.item_mobile_make }} {{ values.item_mobile_model }}</vue-text-highlight>
            </a>
          </template>
          <template v-else-if="contextType === 'customer'">
            <div>
              <a
                :href="`/customers/${values.id}`"
                class="text-orange-mia hover:underline"
                target="_blank"
              >
                <vue-text-highlight :queries="highlight">[{{ values.id }}] {{ getCustomerName(values) }}</vue-text-highlight>
              </a>
            </div>
            <div class="mt-2">
              E-Mail: <a
                :href="`/mailto:/${values.item_email}`"
                class="text-orange-mia hover:underline"
              ><vue-text-highlight :queries="highlight">{{ values.item_email }}</vue-text-highlight></a>
            </div>
          </template>
          <template v-else-if="['seller', 'dispatchEmployee'].includes(contextType)">
            <a
              :href="`/user/profile/${values.id}`"
              class="text-orange-mia hover:underline"
              target="_blank"
            >
              <vue-text-highlight :queries="highlight">[{{ values.id }}] {{ values.item_firstname }} {{ values.item_lastname }}</vue-text-highlight>
            </a>
          </template>
          <div v-else>
            <pre>{{ values }}</pre>
          </div>
        </div>
      </div>
    </div>

    <mia-modal-footer class="flex items-center justify-end">
      <mia-cancel-button
        label="Schließen"
        type="button"
        size="small"
        :disabled="$wait.any"
        @click="$emit('closed')"
      />
    </mia-modal-footer>
  </mia-modal>
</template>
